// intercepts all HTTP requests and adds the JWT token to the Authorization header if the user is logged in

import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from "../../../environments/environment.local";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private oauthService: OAuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.oauthService.hasValidAccessToken()) {
      const headers = req.headers
        .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`)
        .set('Ocp-Apim-Subscription-Key', environment.subscriptionKey)
        .set('User-Identifiant', this.oauthService.getIdentityClaims()['sub']);
      const authReq = req.clone({headers});
      return next.handle(authReq);
    } else {
      return next.handle(req);
    }
  }
}
